var _templateObject;

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import React from 'react';
import i18n from '@pureartisan/simple-i18n';
import { getRoundedValue } from './../utils';
import styled from 'styled-components';
var DemographicStat = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  margin-top: 1.5rem;\n  min-width: 50%;\n  max-width: 50%;\n  span {\n    max-width: 140px;\n  }\n"])));

var DemographicsPanel = function DemographicsPanel(_ref) {
  var activeFeature = _ref.activeFeature,
      props = _objectWithoutPropertiesLoose(_ref, ["activeFeature"]);

  var demographics = Object.keys(activeFeature.properties).filter(function (el) {
    return el.indexOf('_sd') < 0 && el.indexOf('popE') > -1;
  }).map(function (el) {
    return {
      id: el,
      value: activeFeature.properties[el]
    };
  });
  var demoTotal = demographics.find(function (el) {
    return el.id.indexOf('tot') > -1;
  });
  return /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement("h3", {
    className: "gotham16 mb-5"
  }, i18n.translate("PANEL_LOCATION_DEMO")), /*#__PURE__*/React.createElement(DemographicStat, null, /*#__PURE__*/React.createElement("span", {
    className: "knockout12 grey2"
  }, i18n.translate(demoTotal.id)), /*#__PURE__*/React.createElement("span", {
    className: "gotham18"
  }, getRoundedValue(demoTotal.value))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-wrap"
  }, demographics.filter(function (el) {
    return el.id.indexOf('tot') < 0;
  }).sort(function (a, b) {
    return b.value - a.value;
  }).map(function (d) {
    return /*#__PURE__*/React.createElement(DemographicStat, {
      key: "demo-" + d.id
    }, /*#__PURE__*/React.createElement("span", {
      className: "knockout12 grey2"
    }, i18n.translate(d.id)), /*#__PURE__*/React.createElement("span", {
      className: "gotham18"
    }, getRoundedValue(d.value)));
  })));
};

export default DemographicsPanel;